import React, { useContext, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import InicioContext from "./InicioContext";

import "react-circular-progressbar/dist/styles.css";
import "./styles/Progress.css";

export default function Progress() {
  const data = useContext(InicioContext);
  const {
    statusStyle,
    SelectBook,
    lectureStarted,
    count,
    close,
  } = data;
const [seeMore, setSeeMore] = useState(false);
  
  function startTimer() {
    setTimeout(() => {
      lectureStarted();
    }, 1000);
  }



  return (
 
      <div className={statusStyle}>
        <button className="close" onClick={close}>
          <i className="fa-solid fa-xmark"></i>
        </button>
        <div className="book-data">
          <div className="titulo-image">
            <h2 className={"titulo"}>{SelectBook.titles}</h2>
            <img src={SelectBook.imgs} alt={SelectBook.titles} />
          </div>
          <div>
            <h5 className={seeMore ? "description see-less": "description see-more"}>{SelectBook.desc} </h5>
            <h5
              className={"see-more"}
              onClick={()=>{setSeeMore(!seeMore);}
              }>
              {seeMore ? "Ler Menos.." : "Ler Mais..."}
            </h5>
            <h3 className={"titulo"}>{SelectBook.pages} Pag</h3>
          </div>
        </div>
        <div className={"circle"}>
          <CircularProgressbar
            value={count * 14.28}
            text={
              count === 7
                ? "Finalizado"
                : count
                ? count + (count === 1 ? " dia" : " dias")
                : "Começar"
            }
          />
          {count === 7 ? startTimer() : (
            <button onClick={lectureStarted} className="Lido">
              Eu Li Hoje
            </button>
          )}
        </div>
        <button className={"button-start"} onClick={lectureStarted}>
          Start Lecture
        </button>
      </div>
 
  );
}
